<template>
<div>
  <div class="title text-xs-center mb-3">
    {{ $vuetify.t('$vuetify.order.orderDetails') }}
  </div>

  <reward-options-card v-if="!!getActiveRewards"
    :rewardOption="getActiveRewards"
  />

  <punch-card v-for="punchCard in getPunchCards"
    :key="punchCard.id"
    :punchCard="punchCard"
    immutable
  />

  <div v-for="coupon in serverCoupons" :key="coupon.code" style="padding: 10px;">
    <coupon-card v-if="coupon.orderItem"
      :coupon="coupon"
      showItems
      immutable
    />
  </div>

  <ul class="cart-list order-detail text-xs-left">
    <li v-for="(item, index) in getOrderItemList" :key="index" class="pt-2">
      <template v-if="!!item.childItemList && !!item.childItemList.length">
        <cart-menu-item-display
          :item="item"
          :price="item.itemPrice-item.relationPrice"
          :index="index"
          immutable
        />

        <div v-for="(child, childIndex) in item.childItemList" style="margin-top: 10px !important" :key="child.uuid">
          <template v-if="child.childItemList && child.childItemList.length && child.childItemList[0].code != -1">
            <b style="padding-left: 8% !important">
              {{ child.name | capatalize }}
            </b>

            <cart-menu-item-display v-for="(side, sideIndex) of child.childItemList" :key="side.code"
              :item="side"
              :price="child.childItemList[sideIndex].price"
              :index="index"
              :is-side="true"
              immutable
            />
          </template>
        </div>
      </template>
      <cart-menu-item-display v-else :item="item" :index="index" immutable />
    </li>
  </ul>

  <div class="order-divider mt-2"></div>

  <v-layout v-if="isBillLoading" justify-center>
    <v-progress-circular
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="mt-3 mb-3"
    ></v-progress-circular>
  </v-layout>
  <div v-else class="order-totals">
    <div>
      {{ $vuetify.t('$vuetify.cart.subtotal') }}
      <span>{{getBill.subTotalAmount | currency | comma}}</span>
    </div>

    <coupon-details v-if="showDiscountLine" />

    <div class="order-faded" v-if="isDelivery && getBill.deliveryCharge >= 0">
      {{ $vuetify.t('$vuetify.cart.deliveryFee') }}
      <span>{{getBill.deliveryCharge | currency | comma}}</span>
    </div>

    <template v-for="(charge, chIndex) in getBill.serviceCharges">
      <div class="order-faded" :key="`bill_charge_${chIndex}`">
        {{ charge.name || $vuetify.t('$vuetify.cart.serviceFee')}}

        <v-tooltip bottom v-if="charge.info">
          <template v-slot:activator="{ on }">
            <v-icon
              style="top: -2px; position: relative"
              small
              v-on="on"
            >
              info
            </v-icon>
          </template>

          {{ charge.info }}
        </v-tooltip>

        <span>{{(charge.amount || 0) | currency | comma }}</span>
      </div>
    </template>

    <div class="order-faded">
      {{ $vuetify.t('$vuetify.cart.tax') }}
      <span>{{ getBill.totalTax | currency | comma }}</span>
    </div>

    <div v-if="showTips && !!(tipsAmount+tipsForStore)">
      {{ $vuetify.t('$vuetify.cart.tip') }}
      <span>{{ tipsAmount+tipsForStore | currency | comma }}</span>
    </div>

    <div v-if="getBill.rewardsCashback && getBill.rewardsCashback > 0" class="order-rewards">
      {{ $vuetify.t('$vuetify.account.rewards.creditsEarned', membershipTitle) }}
      <span>{{ getBill.rewardsCashback / 100 | currency }}</span>
    </div>

    <div v-if="getBill.rewardPoints > 0 && !optOutRewards " class="order-rewards">
      {{ $vuetify.t('$vuetify.cart.rewards') }}
      <span>{{getBill.rewardPoints}} pts</span>
    </div>

    <coupon-input />

    <template v-if="showTips">
      <template v-if="showMultipleTips">
        <tips ref="tipInput"
          :amount.sync="tipsAmount"
          :percent.sync="tipsPercent"
          :label="$vuetify.t('$vuetify.cart.tipDriver')"
          :type="'DRIVER'"
          set-default
        />

        <div style="height: 15px"></div>

        <tips ref="tipInput2"
          :amount.sync="tipsForStore"
          :percent.sync="storeTipsPercentage"
          :label="$vuetify.t('$vuetify.cart.tipStore')"
          :type="'STORE'"
        />
      </template>
      <div v-else class="pt-2">
        <tips ref="tipInput"
            :type="singleTipForDriver ? 'DRIVER' : 'STORE'"
            :amount.sync="tipsAmount"
            :percent.sync="tipsPercent"
            :label="singleTipForDriver ? $vuetify.t('$vuetify.cart.tipDriver') : $vuetify.t('$vuetify.cart.tipStore')"
            set-default
        />
      </div>
    </template>

    <div class="order-grand-total">
      {{ $vuetify.t('$vuetify.cart.total') }}
      <span>{{getTotal | currency | comma}}</span>
    </div>

    <v-layout v-if="showUtensilsOption" row fill-height class="utensilsRow align-center">
      <v-flex xs2>
        <v-icon large color="green">
          eco
        </v-icon>
      </v-flex>

      <v-flex xs class="utensilsRowText noSelect">
        <label for="includeUtensils">
          <b v-if="getOrderType == 'DINE_IN'">
            {{ $vuetify.t('$vuetify.checkout.deliveryDisposables') }}
          </b>
          <b v-else>
            {{ $vuetify.t('$vuetify.checkout.orderDisposables') }}
          </b>

          <div id="subtitle">
            {{ $vuetify.t('$vuetify.checkout.disposablesIncluded') }}
          </div>
        </label>
      </v-flex>

      <v-flex xs2 align-end>
        <v-switch id="includeUtensils" align-end v-model="includeCutlery" />
      </v-flex>
    </v-layout>
  </div>
</div>
</template>

<script>
import get from 'lodash/get';

import { mapGetters, mapMutations } from 'vuex';
import { matchTranslation, isNullOrEmpty } from '@/services/util.service';


import Tips from "@/components/Checkout/Tips"
import CouponInput from "@/components/Checkout/CouponInput"
import CouponDetails from "@/components/Checkout/CouponDetails"

import CommonPrice from "@/components/Common/CommonPrice"
import PunchCard from "@/components/Common/PunchCard"
import CouponCard from '@/components/Coupons/CouponCard'
import RewardOptionsCard from "@/components/RewardsOptions/RewardOptionsCard"
import CartMenuItemDisplay from '@/components/CartMenuItemDisplay'

export default {
  components: {
    Tips,
    CouponInput,
    CouponDetails,
    CommonPrice,
    PunchCard,
    CouponCard,
    RewardOptionsCard,
    CartMenuItemDisplay
  },

  computed: {
    optOutRewards: {
      get() {
        return get(this.getCheckoutInfo, 'optOutRewards', false)
      }
    },
    tipsAmount: {
      get() {
        return get(this.getCheckoutInfo, 'tipsAmount', 0)
      },
      set(value) {
        this.SET_CHECKOUT_INFO({
          ...this.getCheckoutInfo,
          tipsAmount: value
        })
      }
    },
    tipsPercent: {
      get() {
        return get(this.getCheckoutInfo, 'tipsPercent', 0)
      },
      set(value) {
        this.SET_CHECKOUT_INFO({
          ...this.getCheckoutInfo,
          tipsPercent: value
        })
      }
    },
    tipsForStore: {
      get() {
        return this.showMultipleTips ? get(this.getCheckoutInfo, 'tipsForStore', 0) : 0
      },
      set(value) {
        this.SET_CHECKOUT_INFO({
          ...this.getCheckoutInfo,
          tipsForStore: value
        })
      }
    },
    storeTipsPercentage: {
      get() {
        return get(this.getCheckoutInfo, 'storeTipsPercentage', 0)
      },
      set(value) {
        this.SET_CHECKOUT_INFO({
          ...this.getCheckoutInfo,
          storeTipsPercentage: value
        })
      }
    },
    includeCutlery: {
      get() {
        return get(this.getCheckoutInfo, 'includeCutlery', false)
      },
      set(value) {
        this.SET_CHECKOUT_INFO({
          ...this.getCheckoutInfo,
          includeCutlery: value
        })
      }
    },

    getOrderItemList() {
      return get(this.getServerCart, 'subOrderList[0].orderItemList', []) || []
    },

    singleTipForDriver() {
      return this.getOrderType === 'DELIVERY'
              && get(this.getStore, 'settings.deliverySettings.enableTipForStore', false) === false
    },

    serverCoupons() {
      return get(this.getServerCart, 'subOrderList[0].coupons', [])
    },

    showDiscountLine() {
      return this.getBill.discountAmount < 0 || this.hasAnyCouponAppliedToBill
    },

    membershipTitle() {
      const _customName = get(this.getStore, 'settings.membershipSettings.customMembershipName')

      if (!!_customName) {
        const _translation = matchTranslation(_customName.translations)

        if (!!_translation)
          return _translation;
      }

      return this.$vuetify.t('$vuetify.account.rewards.credits')
    },

    ...mapGetters([
      'getStore',
      'showTips',
      'showMultipleTips',
      'getCheckoutInfo',
      'isBillLoading',
      'isDelivery',
      'getLocalCart',
      'getServerCart',
      'getExistingOrder',
      'getBill',
      'getTotal',
      'getPaymentType',
      'getOrderType',
      'showUtensilsOption',
      'getActiveRewards',
      'getPunchCards',
      'hasAnyCouponAppliedToBill'
    ])
  },

  methods: {
    ...mapMutations([ 'SET_CHECKOUT_INFO' ])
  },

  created() {
    if (!!this.getCheckoutInfo && typeof this.getCheckoutInfo == 'object') {
      if (!this.showTips) {
        // Reset all tips information if no tips control panel is shown
        this.getCheckoutInfo.tipsAmount = 0
        this.getCheckoutInfo.tipsPercent = 0
        this.getCheckoutInfo.tipsForStore = 0
        this.getCheckoutInfo.storeTipsPercentage = 0
      } else if (!this.showMultipleTips) {
        //  Reset the store tips (secondary tips) if they are not shown
        this.getCheckoutInfo.tipsForStore = 0
        this.getCheckoutInfo.storeTipsPercentage = 0
      }
    }
  }
}
</script>

<style>
  .strikethrough {
    text-decoration: line-through;
    text-decoration-color: red;
  }

  .order-divider {
    border-top: 1px solid #000;
  }

  .order-totals {
    font-size: var(--text-size-1) !important;
    text-align: left;
    padding: 10px;
  }

  .order-totals span {
    float: right;
  }

  .order-faded {
    color: #7d7d7d;
  }

  .order-grand-total {
    padding-top: 15px;
    font-weight: 600;
  }

  .cart-list {
    padding-left: 0px;
    list-style: none;
  }

  .order-detail {
    padding: 0px 10px;
  }

  .order-rewards {
    color: rgb(0, 146, 165);
  }

  .special-request {
    color: #999999
  }

  .utensilsRow {
    margin-top: 20px;
    padding-right: 10px;
  }
  .utensilsRowText {
    text-align: left;
    padding: 0px 15px 0px 10px;
  }
  .utensilsRow .xs2 {
    min-width: 40px !important;
    max-width: 40px !important;
  }

  .PunchCardsContainer .PunchCard {
    max-height: 350px;
  }

  .utensilsRowText label div {
    font-size: var(--text-size-sub) !important;
  }

  .cart-list.order-detail>li {
    background-color: rgba(220, 220, 220, 0.15);
    margin-bottom: 20px;
    border-radius: 5px;
  }
</style>
<style scoped>
  .title {
    font-size: var(--text-size-2) !important;
    font-weight: 700;
  }

</style>
